import { CallAPI } from "../../apiManager/ApiCall";
import {
  translatePinURL,
  translateAnatomyAnnotationURL,
  translateAnatomyAnnotationsForSlideURL,
} from "../../apiManager/APIConfig";

/**
 * Translate the title + body of ONE slide pin into every supported
 * app locale. **UPSERT** — re-running OVERWRITES any existing
 * per-locale value for the pin. Source is auto-picked: EN if present,
 * otherwise the first existing locale.
 *
 * Resolves to:
 *   { status, message, appLangs,
 *     pinId, sourceLang, targetLangs,
 *     results: [{lang, action: "created"|"updated"}],
 *     created, updated }
 */
export const translatePinCall = async (pinId) => {
  if (!pinId) return { status: 400, message: "Missing pin id." };
  return CallAPI({
    url: translatePinURL,
    method: "POST",
    body: { pin_id: pinId },
  });
};

/**
 * Translate the name + description of ONE 3D-model annotation into
 * every supported app locale. **UPSERT** — re-running overwrites
 * any existing per-locale row.
 */
export const translateAnatomyAnnotationCall = async (
  annotationId,
  { sourceLang } = {},
) => {
  if (!annotationId)
    return { status: 400, message: "Missing annotation id." };
  return CallAPI({
    url: translateAnatomyAnnotationURL,
    method: "POST",
    body: {
      annotation_id: annotationId,
      ...(sourceLang ? { source_lang: sourceLang } : {}),
    },
  });
};

/**
 * Translate EVERY annotation on a given 3D slide. Convenience for
 * "I just finished labelling this model, ship it in all languages."
 */
export const translateAnatomyAnnotationsForSlideCall = async (
  slideId,
  { sourceLang } = {},
) => {
  if (!slideId) return { status: 400, message: "Missing slide id." };
  return CallAPI({
    url: translateAnatomyAnnotationsForSlideURL,
    method: "POST",
    body: {
      slide_id: slideId,
      ...(sourceLang ? { source_lang: sourceLang } : {}),
    },
  });
};
